import type { IconProps } from "@mui/material";
import { SmsSentStatus } from "@root/utils/enums/communication";

export const smsIcons: Record<SmsSentStatus, { icon: IconProps["children"]; color: IconProps["color"] }> = {
  [SmsSentStatus.PENDING]: {
    icon: "access_time",
    color: "warning",
  },
  [SmsSentStatus.SENT]: {
    icon: "done_all",
    color: "success",
  },
  [SmsSentStatus.RE_SENT]: {
    icon: "error_outline",
    color: "error",
  },
  [SmsSentStatus.MESSAGE_REJECTED]: {
    icon: "error_outline",
    color: "error",
  },
  [SmsSentStatus.SMS_REJECTED]: {
    icon: "error_outline",
    color: "error",
  },
  [SmsSentStatus.NO_DELIVERED]: {
    icon: "error_outline",
    color: "error",
  },
};
